import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../Elements/buttons/Button'
import { ButtonsGroup } from './index.styled'

const FooterButton = React.memo(({ state, handlers }) => {
	const { t } = useTranslation()

	switch (state) {
		case 'not-connected':
			return <Button name="generate" icon="plus" text={t('watch.connect.button')} color="blue" className="btn-center fullWidth" onClick={handlers.generate} testId="generate-button" />
		case 'code':
			return <Button name="cancel" icon="clear" text={t('watch.code.cancel')} color="gray" className="btn-center fullWidth" onClick={handlers.cancelCode} testId="cancel-button" />
		case 'connected':
			return <Button name="delete" icon="basket" text={t('watch.connected.deleteButton')} color="red" className="btn-center fullWidth" onClick={handlers.askDelete} testId="delete-button" />
		case 'delete-confirm':
			return (
				<ButtonsGroup className="btn-center">
					<Button name="delete-confirm" icon="basket" text={t('watch.deleteConfirm.deleteButton')} color="red" onClick={handlers.confirmDelete} testId="delete-confirm-button" />
					<Button name="cancel" icon="clear" text={t('watch.deleteConfirm.cancelButton')} color="gray" onClick={handlers.cancelDelete} testId="cancel-delete-button" />
				</ButtonsGroup>
			)
		case 'deleted':
			return <Button name="reconnect" icon="plus" text={t('watch.deleted.reconnectButton')} color="blue" className="btn-center fullWidth" onClick={handlers.reconnect} testId="reconnect-button" />
		default:
			return null
	}
})

FooterButton.displayName = 'FooterButton'
export default FooterButton
